import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersModalCreate.vue?vue&type=template&id=5287a1e6&"
import script from "./MoleculeEditionAcademyUsersModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports